(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morelife-delivery-callouts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const observer = new IntersectionObserver(
      (entries) => {
        for (const { target, isIntersecting } of entries) {
          if (isIntersecting && !reducedMotion.matches) {
            target.play().catch(() => {});
          } else {
            target.pause();
          }
        }
      },
      { rootMargin: '200px' }
    );

    const init = (root) => {
      root.querySelectorAll('.ml-dc__video:not([data-ml-dc-ready])').forEach((video) => {
        video.dataset.mlDcReady = '';
        video.muted = true;
        observer.observe(video);
      });
    };

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
